module.exports = __webpack_public_path__ + "img/cg_banner.dad409cf.png";